<section class="cst_body">
  <div class="container-fluid search_flt_box_main">
      <div class="search_flt_box">
        <div class="row">

          <div class="col-2">
            <div class="form-group">
                <button type="submit" class="btn green_btn" (click)="redirectAddUser()">Add Users</button>
            </div>
          </div>


        </div>
      </div>
  </div>
  
  <div class="container-fluid" role="main">
    <div class="table_main tableShadow">
      <!--<div class="tbl_name">
        All Reimbursement <span class="fnt-medium">({{datacount}})</span>
      </div>-->
      <table class="table table-striped table-responsive">
        <thead>
          <tr  class="tbl_name">
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile No</th>
            <th>Status</th>
            <th>Associate Name</th>
            <th>Branch Name</th>
            <th>Role Type</th>
            <th>Officer ID</th>
            <th>TenantOrgInfo</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <!--<tr *ngFor="let reimbursListObj of reimbursListRes;let i = index">

            <td>{{reimbursListObj.claimId}}</td>
            <td>{{reimbursListObj.transactionId}}</td>
            <td>{{reimbursListObj.employeeId}}</td>
            <td>{{reimbursListObj.mrn}}</td>
            <td>{{reimbursListObj.customerName}}</td>
            <td>{{reimbursListObj.businessName}}</td>
            <td>{{reimbursListObj.lineitemAmount}}</td>
            <td>{{reimbursListObj.requestedAmount}}</td>
            <td>{{reimbursListObj.approvedAmount}}</td>
            <td>{{reimbursListObj.claimStatus}}</td>
            <td>{{reimbursListObj.createdDate | date:'dd/MM/yyyy hh:mm a'}}</td>
            <td>
              <img class="exitImg" src="./assets/img/eye.png"
                
                ngbTooltip="View Details">
            </td>

          </tr>-->

        </tbody>
      </table>

    </div>
    
    <!--<div  class="noRecord" *ngIf="reimbursListRes?.length == 0"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="reimbursListRes?.length">
      <div class="totalRecords">
        Total Reimbursements <span class="fnt-medium">({{datacount}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
    </ngb-pagination>
     </div>
     </div>-->

  </div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>


</section>